exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Toast-container{position:fixed;left:50%;top:0;transform:translateX(-50%);z-index:999;text-align:center}.Toast-container,.Toast-item{width:auto;display:inline-block}.Toast-item{margin-top:10px;padding:8px 8px 7px;animation:toast linear .3s;cursor:pointer;border:1px solid;border-radius:2px;max-width:290px;font-size:14px}.Toast-item p{margin:0;cursor:pointer}.Toast-item--out{animation:toastOut linear .3s}.Toast-item--success{background-color:#4caf50;color:#fff;border-color:rgba(76,175,80,.5)}.Toast-item--warning{background-color:#fffdc8;color:#08152e;border-color:rgba(255,253,200,.5)}.Toast-item--danger{background-color:#fd7365;color:#fff;border-color:hsla(6,97%,69%,.5)}@keyframes toast{0%{transform:translateY(-150px);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes toastOut{0%{transform:translateY(0);opacity:1}to{transform:translateY(100%);opacity:0}}@media(min-width:768px){.Toast-item{max-width:550px}}", ""]);

// exports
exports.locals = {
	"Toast-container": "Toast-container",
	"Toast-item": "Toast-item",
	"toast": "toast",
	"Toast-item--out": "Toast-item--out",
	"toastOut": "toastOut",
	"Toast-item--success": "Toast-item--success",
	"Toast-item--warning": "Toast-item--warning",
	"Toast-item--danger": "Toast-item--danger"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Toast/Toast.scss
 ** module id = 159
 ** module chunks = 0
 **/